import { render, staticRenderFns } from "./BedInTwinOld.vue?vue&type=template&id=1d19fdee&"
import script from "./BedInTwinOld.vue?vue&type=script&lang=js&"
export * from "./BedInTwinOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports